import request from '../config/request';

export type ReferralFingerprintPayload = {
  fingerprint: string;
  referralCode?: string | null;
  metadata?: Record<string, unknown>;
};

export const registerReferralFingerprint = (body: ReferralFingerprintPayload) => {
  return request({
    url: '/app/referral/fingerprint',
    method: 'POST',
    body,
    customURl: true,
  });
};

